export * from "gl-matrix";
import { glMatrix } from "gl-matrix";
glMatrix.setMatrixArrayType(Array);
